"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFocusWithin = exports.default = void 0;
var _react = require("react");
const useActiveElement = () => {
  const [activeElement, setActiveElement] = (0, _react.useState)(typeof document !== 'undefined' && (document === null || document === void 0 ? void 0 : document.activeElement));
  (0, _react.useEffect)(() => {
    let unMounted = false;
    const onDocumentBlur = event => {
      if (event.relatedTarget !== null || unMounted) {
        return;
      }
      setActiveElement(document.activeElement);
    };
    const onDocumentFocus = () => {
      if (unMounted) {
        return;
      }
      setActiveElement(document.activeElement);
    };
    document.addEventListener('blur', onDocumentBlur, true);
    document.addEventListener('focus', onDocumentFocus, true);
    return () => {
      unMounted = true;
      document.removeEventListener('blur', onDocumentBlur);
      document.removeEventListener('focus', onDocumentFocus);
    };
  }, []);
  return activeElement;
};
const useFocusWithin = ({
  targetElement
}) => {
  const activeElement = useActiveElement();
  return {
    isFocused: targetElement && activeElement ? targetElement.contains(activeElement) : false
  };
};
exports.useFocusWithin = useFocusWithin;
var _default = exports.default = useFocusWithin;